import { CHECKLIST_ITEMS } from '@ria-client/advisor-search/constants';
import { Section } from '@ria-client/tw-shared-ui/layout/section';
import type { ReactNode } from 'react';

import { SectionHeader } from './SectionHeader';
import { CheckIcon, FactCheckIcon } from './icons';

export type DueDiligenceChecklistProps = { cta: ReactNode };

export function DueDiligenceChecklist({ cta }: DueDiligenceChecklistProps) {
  return (
    <Section aria-label="Investment Advisor Due Diligence Checklist" spacing="bottom">
      <div className="flex flex-col items-start gap-8 rounded-callout bg-gradient-to-br from-callout-gradient-start via-callout-gradient-middle to-callout-gradient-end p-8 text-primary-foreground md:flex-row md:gap-12 md:p-12">
        <div className="callout-content">
          <SectionHeader
            icon={<FactCheckIcon className="size-4" />}
            title="Investment Advisor Due Diligence Checklist"
            subtitle="Use this checklist before signing with any investment advisor."
            variant="dark"
          />
          <div className="inline-flex flex-col items-center gap-2">{cta}</div>
        </div>
        <ul className="callout-list list-none space-y-3">
          {CHECKLIST_ITEMS.map((item, index) => (
            <li key={index} className="flex items-start gap-3">
              <span className="flex size-6 shrink-0 items-center justify-center rounded-md border border-primary-foreground/15 bg-primary-foreground/8 text-primary-foreground">
                <CheckIcon className="size-3" />
              </span>
              <span className="typography-text-small pt-1 text-primary-foreground/80">{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </Section>
  );
}
